import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {Leasing} from "../../../../../../../../../server/src/base/entities/leasing/Leasing";
import {LeasingType} from "../../../../../../../../../server/src/base/entities/leasing/LeasingType";
import {LeasingDetailsComponent} from "./leasingDetails/leasingDetails";

@Component({
    selector: 'leasing',
    styleUrls: ['./leasing.scss'],
    templateUrl: './leasing.html'
})
export class LeasingComponent {

    @Input() leasing:Leasing;
    @Output() booked:EventEmitter<LeasingType> = new EventEmitter<LeasingType>();

    @ViewChild(LeasingDetailsComponent) leasingDetails:LeasingDetailsComponent;

    public book(){
        this.booked.emit(this.leasing.type);
    }

    public details(){
        this.leasingDetails.Open();
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/leasing/presentation/leasing/leasing.ts